module.exports = __webpack_public_path__ + "4588117b5eb29f707881089c2f9fb415.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/festival-yurt-empty.png
// module id = 318
// module chunks = 0